import { Button } from '@components/button';
import { createForm } from '@components/form';
import { IconAddPlus } from '@components/icons/add-plus';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { disabledSectionStyle } from '@styles/theme';

import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

import { Cosigner, EditCosigner, useManageSignetCosigner } from './api';

const Form = createForm<EditCosigner>();

export const SignetCosignerModal = ({
  closeModal,
  cosigner,
}: ModalProps<{ cosigner?: Cosigner }>) => {
  const { t } = useStore();
  const submit = useManageSignetCosigner(cosigner?.id, { onSuccess: closeModal });
  const isEditing = cosigner !== undefined;

  return (
    <Stack space={6} style={submit.isLoading ? disabledSectionStyle : undefined}>
      <Text
        font="heading2"
        text={
          isEditing
            ? t('integrations.signet.settings.cosigners.modal.edit.header')
            : t('integrations.signet.settings.cosigners.modal.header')
        }
      />
      <Form onSubmit={(values) => submit.mutateAsync(values)}>
        <Form.TextField
          id="name"
          label={t('integrations.signet.settings.cosigners.modal.name.label')}
          validators={['required']}
          defaultValue={cosigner ? cosigner.name : ''}
        />
        <Form.TextField
          id="email"
          label={t('integrations.signet.settings.cosigners.modal.email.label')}
          validators={['required', 'email']}
          defaultValue={cosigner ? cosigner.email : ''}
        />
        <Form.TextField
          id="ssn"
          label={t('integrations.signet.settings.cosigners.modal.ssn.label')}
          validators={['required', 'ssn']}
          defaultValue={cosigner ? cosigner.ssn : ''}
        />
        <Form.Actions>
          <Button
            variant="secondary"
            text={t('integrations.signet.settings.cosigners.modal.cancel')}
            onClick={closeModal}
          />
          <Form.Submit
            text={
              isEditing
                ? t('integrations.signet.settings.cosigners.modal.save')
                : t('integrations.signet.settings.cosigners.modal.submit')
            }
            iconLeft={isEditing ? undefined : <IconAddPlus />}
          />
        </Form.Actions>
      </Form>
    </Stack>
  );
};
